import { render } from "./SingleHeader.vue?vue&type=template&id=85d005e6"
import script from "./SingleHeader.vue?vue&type=script&lang=js"
export * from "./SingleHeader.vue?vue&type=script&lang=js"

import "./SingleHeader.vue?vue&type=style&index=0&id=85d005e6&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__